import {
  watch
} from "./chunk.2NT6DI7B.js";
import {
  WebAwesomeElement,
  n,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/components/divider/divider.css
var divider_default = ":host {\n  --color: var(--wa-color-surface-border);\n  --width: var(--wa-border-width-s);\n  --spacing: var(--wa-space-m);\n}\n\n:host(:not([vertical])) {\n  display: block;\n  border-top: solid var(--width) var(--color);\n  margin: var(--spacing) 0;\n}\n\n:host([vertical]) {\n  display: inline-block;\n  height: 100%;\n  border-left: solid var(--width) var(--color);\n  margin: 0 var(--spacing);\n}\n";

// src/components/divider/divider.ts
var WaDivider = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.vertical = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("role", "separator");
  }
  handleVerticalChange() {
    this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
  }
};
WaDivider.shadowStyle = divider_default;
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaDivider.prototype, "vertical", 2);
__decorateClass([
  watch("vertical")
], WaDivider.prototype, "handleVerticalChange", 1);
WaDivider = __decorateClass([
  t("wa-divider")
], WaDivider);

export {
  WaDivider
};
